import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-slide',
  standalone: true,
  imports: [],
  templateUrl: './slide.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlideComponent {}
